import { SIGNUP_FAIL, SIGNUP_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const signupReducer = (state = initialState, action) => {
	switch (action.type) {
		case SIGNUP_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case SIGNUP_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}
	return state;
};

export default signupReducer;
